import styled from 'styled-components'

export const BodyContainer = styled.div`
    background-color: clear;
    padding: 0px var(--ps-body);
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    alignItems: flex-start;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;
`
